import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import { getPaymentMethods, deletePaymentMethod, updatePaymentMethod } from "../../../MyApi/paymentmethods";

import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import AddPaymentModal from "../addpaymentmodal";
import Can from "../../../utils/can";
import i18next from "i18next";

const PaymentMethodsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);

  const {
    data,
    isLoading: isLoadingMethods,
    isFetching,
    refetch,
  error
  } = useQuery("getPaymentMethods", () => getPaymentMethods());



  const openModal = () => {
    setIsModalOpen(true);
    setModalMode("add");
    setModalId(null);
  };

  const handleOpenModal = (mode, id) => {
    setIsModalOpen(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
 const paymentMethodsColumns = [
  { label: "طرق الدفع", accessor: "name" },
  { label: "النوع", accessor: "code" },
  {label:"الحالة " ,  render:(row)=>(
 <StatusBadge status={row.is_active ?"active":""}/>
  )
   
  },
  // { label: "مزود الخدمة", accessor: "store_name" },

  // { label: "تفعيل كإفتراضي", accessor: "discount" },
  // { label: "تاريخ الطلب", accessor: "start_date" },

  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
    
        edit={() =>handleOpenModal("edit",row.id)}
        deleteFn={deletePaymentMethod}
        id={row.id}
        mutationKey={"deletePaymentMethod"}
        deletePermission={"delete_payment_method"}
        editPermission={"update_payment_method"}
        viewPermission={"view_payment_method"}
        togglePermission={"update_payment_method"}
        toggleMutationKey={"toggle-update-payment-method"}
        queryKey={"getPaymentMethods"}
        toggleFn={(id, status) => updatePaymentMethod( {is_active:status ,"_method":"PUT" , lang:i18next.language},id)}
        is_active={row.is_active}
      />
    ),
  },
];
  return (
    <Can permission={"view_payment_method"}>
      <DataTable
        columns={paymentMethodsColumns}
        data={data?.data || []}
        title="طرق الدفع"
        actionLabel="إضافة طرق دفع "
        onAddClick={openModal}
        isLoading={isLoadingMethods}
        createPermission={"create_payment_method"}
        isFetching={isFetching}
        error={error}
        updatePaymentMethod={updatePaymentMethod}
        refetch={refetch}
      />

      <AddPaymentModal
        isOpen={isModalOpen}
        toggle={closeModal}
        refetch={refetch}
        modalMode={modalMode}
        modalId={modalId}
      />
    </Can>
  );
};

export default PaymentMethodsTab